import { ActionIcon, type ActionIconVariant, type MantineColor, type MantineSize, Popover, type PopoverProps } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import type { PropsWithChildren } from "react";

type InfoCardPopoverProps = PropsWithChildren<
  PopoverProps & {
    buttonSize?: MantineSize;
    buttonColor?: MantineColor;
    buttonVariant?: ActionIconVariant;
  }
>;

export function InfoCardPopover({
  buttonSize = "sm",
  buttonColor = "zli-blue",
  buttonVariant = "transparent",
  children,
  position = "top-start",
  ...props
}: InfoCardPopoverProps) {
  return (
    <Popover position={position} {...props}>
      <Popover.Target>
        <ActionIcon size={buttonSize} color={buttonColor} variant={buttonVariant}>
          <IconInfoCircle />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown>{children}</Popover.Dropdown>
    </Popover>
  );
}
